import React from 'react';
import { SvgIcon } from '@common/sprites';
import { useTranslation } from 'react-i18next';
import classes from './classes.module.scss';

interface OfflineOrderProps {
  holisticServiceName: string;
  holisticServiceStatus: string;
  onHolisticServiceClick?: () => void;
}
const OfflineOrder: React.FC<OfflineOrderProps> = ({ holisticServiceName, holisticServiceStatus, onHolisticServiceClick }) => {
  const { t } = useTranslation();
  return (
    <div
      className={ classes.offlineOrder }
      role="button"
      tabIndex={ 0 }
      onClick={ () => onHolisticServiceClick?.() }
      onKeyDown={ (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          onHolisticServiceClick?.();
        }
      } }
    >
      <SvgIcon id="holistic" />
      <div className={ classes.offlineOrderTextContainer }>
        <div className={ classes.offlineOrderContent }>
          <div className={ classes.offlineOrderTitle }>{t('holistic_service.holistic_service_offline_order_title')}</div>
          <div className={ classes.offlineOrderDescription }>{holisticServiceName}</div>
        </div>
        <div className={ classes.offlineOrderStatus }>{holisticServiceStatus}</div>
      </div>
      <div className={ classes.rightArrowContainer }>
        <SvgIcon id="right_arrow" className={ classes.rightArrowIcon } size={ 24 } />
      </div>
    </div>
  );
};

export default OfflineOrder;
